// Builds the share URLs. https is used everywhere (the originals used http).
export const getTelegramLink = (url: string, text: string): string =>
    `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;

export const getWhatsappLink = (url: string, text: string): string =>
    `https://wa.me/?text=${encodeURIComponent(`${text}\n${url}`)}`;